module.exports = __webpack_public_path__ + "img/icon4.c0d0d602.png";